module.exports = __webpack_public_path__ + "media/images/favicon-3f892ae960d7963e8cc527314fdb43ef.png";